import React, { useEffect, useRef, useState } from 'react'
import style from './style.module.scss'

export interface LoaderViewProps {
  delay?: number
}

export default function LoaderView({ delay = 500 }: LoaderViewProps) {
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const showSpinnerTimeout = useRef<ReturnType<typeof setTimeout>>(null)

  useEffect(() => {
    showSpinnerTimeout.current = setTimeout(() => void setShowSpinner(true), delay)
    return () => void clearTimeout(showSpinnerTimeout.current)
  }, [delay])

  return (
    <div className={style.LoaderView} data-testid="SW-Loader">
      {showSpinner && <div className={style.spinner}></div>}
    </div>
  )
}
